const state = {
  isOpen: false,
  registrationToken: '',
};

const actions = {
  openRegistrationModal({commit}, registrationToken) {
    commit('OPEN_REGISTRATION_MODAL', registrationToken);
  },
  closeRegistrationModal({commit}) {
    commit('CLOSE_REGISTRATION_MODAL');
  }
};

const mutations = {
  OPEN_REGISTRATION_MODAL(state, registrationToken) {
    state.isOpen = true;
    state.registrationToken = registrationToken;
  },
  CLOSE_REGISTRATION_MODAL(state) {
    state.isOpen = false;
    state.registrationToken = '';
  }
};

export default {
  state,
  actions,
  mutations,
}
